import React, { useEffect, useMemo, useState } from 'react';
import ApproveButtons from '../../../../../../component/ui/buttons/approve-button/approve-buttons';
import CancelButton from '../../../../../../component/ui/buttons/cancel-button/cancel-button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import globalCourseStore from '../../../../../../stores/global-course-store';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import globalProgramStore from '../../../../../../stores/program-store';
import { StudentAssignment } from '../../../../../../api/types/assignment-student-details/request/upsert/request-assignment-details';
import { loadAssignmentDetailsOperations } from './operations/load-assignment-details-operations';
import { AssignmentStudent } from '../../../../../../api/types/assignment-student-details/response/assignment-student-db';
import { upsertStudentsAssignmentData } from './operations/upsert-students-assignment-data';
import { Dialog } from 'primereact/dialog';
import { UploadFile } from '../../../../../user-page/pages/docs/componenets/upload-file/upload-file';
import { FileUploadFile } from 'primereact/fileupload';
import { taskGradeUploadFileOperation } from './task-grades/operations/task-grade-upload-file-operation';
import { downloadFileByUrlOperation } from '../../../../../user-page/pages/docs/componenets/upload-file/operation/download-file-by-url-operation';
import { deleteStudentIdOperation } from './operations/delete-student-id-operation';
import { observer } from 'mobx-react-lite';
import { PhoneNumberComponent } from '../../../../../../utils/international-to-israeli';

type AssignmentData = StudentAssignment[];

interface TaskGradesDatamodel {
  id: number;
  closeDialog: () => void;
}
const TaskGrades: React.FC<TaskGradesDatamodel> = observer(
  ({ id, closeDialog }) => {
    const [studentData, setStudentData] = useState<AssignmentStudent[]>([]);
    const [editDialog, setEditDialog] = useState(false);
    const [studentDataUpdated, setStudentDataUpdated] = useState<
      AssignmentStudent[]
    >([]);
    const [updatedData, setUpdatedData] = useState<
      Map<
        number,
        {
          studentAssignmentId?: number;
          grade?: number;
          dueDate?: Date;
        }
      >
    >(new Map());
    //const [assignments, setAssignments] = useState<AssignmentData>([]);

    const programId = useMemo(() => {
      return globalProgramStore.getCurrentId();
    }, [globalProgramStore.currentId]);

    const courseId = useMemo(() => {
      return globalCourseStore.currentId;
    }, [globalCourseStore.currentId]);

    useEffect(() => {
      const loadData = async () => {
        const data = await loadAssignmentDetailsOperations(
          programId,
          courseId,
          id,
          setStudentData,
        );
        setStudentData(data);
        setStudentDataUpdated(data);
      };
      loadData();
    }, [programId, courseId, globalCourseStore.version]);

    const handleGradeChange = (
      userId: number,
      newGrade: number,
      studentAssignmentDetailsId?: number,
    ) => {
      const initStudentData = studentDataUpdated.find(
        (item) => item.user.id === userId,
      );
      const initAssignmentDetails = initStudentData.assignmentStudentDetails;

      setUpdatedData((prev) => {
        const newMap = new Map(prev);
        const userCurrentData = newMap.get(userId) || {};

        // Merge init data first, then current data to override, then update grade last
        newMap.set(userId, {
          studentAssignmentId: initStudentData.assignmentStudentDetails?.id,
          dueDate:
            userCurrentData.dueDate ?? initAssignmentDetails?.customDueDate,
          grade: newGrade, // Always set newGrade last to ensure it overrides existing grade
        });

        return newMap;
      });
    };

    const handleDateChange = (
      userId: number,
      newDate: Date,
      studentAssignmentDetailsId?: number,
    ) => {
      const initStudentData = studentDataUpdated.find(
        (item) => item.user.id === userId,
      );
      const initAssignmentDetails = initStudentData.assignmentStudentDetails;
      setUpdatedData((prev) => {
        const newMap = new Map(prev);
        const userCurrentData = newMap.get(userId) || {};
        newMap.set(userId, {
          studentAssignmentId: initAssignmentDetails?.id,
          dueDate: newDate,
          grade: userCurrentData.grade ?? initAssignmentDetails?.grade,
        });
        return newMap;
      });
    };

    const handleSave = async () => {
      await upsertStudentsAssignmentData(programId, courseId, id, updatedData);
    };

    const [addStudentIdFileActive, setAddStudentIdFileActive] = useState<
      number | null
    >(null);
    const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();

    const hideUploadFileDialog = () => setAddStudentIdFileActive(null);

    const uploadFile = async () => {
      const currentProgramId = globalProgramStore.getCurrentId();
      const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

      await taskGradeUploadFileOperation(
        currentProgramId,
        currentCourseId,
        id,
        addStudentIdFileActive,
        uploadedFile,
        setStudentData,
        setStudentDataUpdated,
        hideUploadFileDialog,
        closeDialog,
      );
    };

    const downloadAssignmentStudentFile = async (fileUrl: string) => {
      downloadFileByUrlOperation(fileUrl);
    };

    const [deleteStudentFileLoading, setDeleteStudentFileLoading] =
      useState(false);

    const handleDeleteStudentFile = async (studentId: number) => {
      await deleteStudentIdOperation(
        programId,
        courseId,
        id,
        studentId,
        setDeleteStudentFileLoading,
        setStudentData,
        setStudentDataUpdated,
      );
    };

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '95vh',
          justifyContent: 'stretch',
          paddingRight: '15px',
          paddingLeft: '15px',
        }}
      >
        <Dialog
          header="הוספת קובץ"
          visible={addStudentIdFileActive !== null}
          style={{
            width: '40vw',
            /*minWidth: '40wh',*/
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '8px',
          }}
          onHide={() => {
            setAddStudentIdFileActive(null);
          }}
        >
          <UploadFile onFileUploaded={setUploadedFile} />
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}
          >
            <Button
              style={{ height: '35px', marginTop: '16px' }}
              label={'העלאת קובץ'}
              onClick={uploadFile}
            />
          </div>
        </Dialog>

        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          loading={false}
          selectionMode={'multiple'}
          multiple={true}
          value={studentDataUpdated}
          onSelectionChange={(e) => {
            //setSelectedUsers(e.value as UserSummaryType[]);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
          }}
          style={{ marginTop: '16px', width: '100%' }}
        >
          <Column
            field="abstractData.courseHours"
            header="שם"
            sortable
            body={(data: AssignmentStudent) => (
              <div>
                {data.user.firstName} {data.user.lastName}
              </div>
            )}
            style={{ textAlign: 'right' }}
          />
          <Column
            field="abstractData.courseHours"
            header="ת.ז"
            sortable
            body={(data: AssignmentStudent) => (
              <div>{data.user.nationalId}</div>
            )}
            style={{ textAlign: 'right' }}
          />
          <Column
            field="abstractData.courseHours"
            header="טלפון"
            sortable
            body={(data: AssignmentStudent) => (
              <PhoneNumberComponent phoneNumber={data.user.phoneNumber} />
            )}
            style={{ textAlign: 'right' }}
          />
          <Column
            field="abstractData.courseHours"
            header="תאריך הגשה מיוחד"
            sortable
            body={(data: AssignmentStudent) => (
              <div>
                <Calendar
                  style={{
                    height: '30px',
                    direction: 'ltr',
                  }}
                  dateFormat="dd/mm/yy" // Add this line
                  inputStyle={{ textAlign: 'right' }} // Add this line
                  value={
                    data?.assignmentStudentDetails?.customDueDate
                      ? new Date(data?.assignmentStudentDetails?.customDueDate)
                      : undefined
                  }
                  onChange={(e) =>
                    handleDateChange(
                      data.user.id,
                      e.value,
                      data.assignmentStudentDetails?.id,
                    )
                  }
                  showIcon
                  showButtonBar={true}
                  onClearButtonClick={(
                    event: React.MouseEvent<HTMLButtonElement>,
                  ) => {
                    console.log(`Clear clear clear `);
                  }}
                />
              </div>
            )}
            style={{ textAlign: 'right' }}
          />
          {/*        <Column
          field="abstractData.courseHours"
          header="סטטוס"
          sortable
          body={(data: AssignmentStudent) => <div>הוגש</div>}
          style={{ textAlign: 'right' }}
        />*/}
          <Column
            field="abstractData.courseHours"
            header="הגשה"
            sortable
            body={(data: AssignmentStudent) => {
              if (
                data &&
                data.assignmentStudentDetails &&
                data.assignmentStudentDetails.fileUrl &&
                data.assignmentStudentDetails.fileUrl.length > 0
              ) {
                return (
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Button
                      outlined={true}
                      text
                      severity={'warning'}
                      icon="pi pi-download"
                      tooltip={'לחץ להורדה'}
                      onClick={() =>
                        downloadAssignmentStudentFile(
                          data.assignmentStudentDetails.fileUrl,
                        )
                      }
                    />

                    <Button
                      icon="pi pi-trash"
                      text
                      tooltip={'מחיקת הקובץ'}
                      severity="danger"
                      loading={deleteStudentFileLoading}
                      onClick={() => handleDeleteStudentFile(data.user.id)}
                    />
                  </div>
                );
              } else {
                return (
                  <label
                    htmlFor="fileUpload"
                    onClick={() => setAddStudentIdFileActive(data.user.id)}
                    style={{
                      whiteSpace: 'nowrap',
                      color: '#0066cc',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = '#e0e0e0')
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = 'transparent')
                    }
                  >
                    לחץ להגשה
                  </label>
                );
              }
            }}
            style={{ textAlign: 'right' }}
          />
          <Column
            field="abstractData.courseHours"
            header="ציון"
            sortable
            style={{ textAlign: 'right', width: '30px' }}
            body={(data: AssignmentStudent) => (
              <InputNumber
                size={2}
                style={{
                  height: '30px',
                }}
                max={100}
                value={data.assignmentStudentDetails?.grade ?? ''}
                onChange={(e) => {
                  console.log(`XXX data res: ${e.value}`);
                  const studentAssignmentDetailsId =
                    data.assignmentStudentDetails?.assignmentId;
                  handleGradeChange(
                    data.user.id,
                    e.value,
                    studentAssignmentDetailsId,
                  );
                }}
              />
            )}
          />
        </DataTable>

        <Dialog
          header="הוספת מטלה לקורס"
          visible={editDialog}
          style={{
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '8px',
          }}
          onHide={() => setEditDialog(false)}
        >
          {/*<AddEditTaskDialog
          onCancel={() => setEditDialog(false)}
          onApprove={() => {
            //
          }}
        />*/}
        </Dialog>

        {true && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'left',
              marginTop: '10px',
              paddingBottom: '10px',
            }}
          >
            <CancelButton onClick={closeDialog} />

            <div style={{ width: '10px' }} />
            <ApproveButtons onClick={handleSave} />
          </div>
        )}
      </div>
    );
  },
);

export default TaskGrades;
